import filter from 'lodash/filter';
import { useMemo } from 'react';
import React from 'react';
import { Select } from '../../../../base-components/Select';
import { ExtraProps } from '../../../../base-components/Select';
import { Section } from '../../../../types/entities';
import { useMatchesLabel } from '../../hooks/useMatchesLabel';
import { useMultipleValue } from '../../hooks/useMultipleValue';

interface SectionOption {
    value: string;
    label: string;
    matches?: number;
}

export interface Props {
    instanceId: string;
    sections: Section[];
    value: Section[];
    onChange: (value: Section[]) => void;
    className?: string;
    appearance?: ExtraProps['appearance'];
    matches?: { [k: string]: number };
}

type SectionValue = Pick<Section, 'name'>;

/**
 * Селектор секции
 */
export const SelectSection: React.FC<Props> = ({
    instanceId,
    sections,
    value,
    onChange,
    className,
    appearance,
    matches,
}) => {
    const [selectOptions, selectValue, handleChange] = useMultipleValue<
        Section,
        SectionValue,
        SectionOption
    >({
        options: sections,
        key: 'name',
        value,
        onChange,
        createOption: (section: Section): SectionOption => ({
            value: section.name,
            label: section.title || '',
            matches: matches?.[section.id] || 0,
        }),
    });

    const formatOptionLabel = useMatchesLabel<SectionOption>();

    return (
        <Select
            instanceId={instanceId}
            placeholder="Секция ЭТП"
            value={selectValue}
            onChange={handleChange}
            options={selectOptions}
            className={className}
            isMulti={true}
            isSearchable={false}
            isClearable={false}
            appearance={appearance}
            formatOptionLabel={formatOptionLabel}
        />
    );
};
